export default "__VITE_ASSET__DfnAT9k4__"